import { FeedbackFormElementText } from '../../../../../../../../types';

type Props = {
  element: FeedbackFormElementText;
};

function FormText(props: Props) {
  return null;
}

export default FormText;
